export interface GenericModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface PaginatedEndpointParams {
  page?: number;
  limit?: number;
}

export enum ThemeVariant {
  LIGHT = "light",
  DARK = "dark",
}

export enum WebApiPermissionStates {
  PROMPT = "prompt",
  GRANTED = "granted",
  DENIED = "denied",
}

export enum AppEnvs {
  PREVIEW = "preview",
  STAGING = "staging",
  PROD = "prod",
}

export type FunctionWithReturnType<ReturnType> = () => ReturnType;
export type FunctionWithVoidReturn = FunctionWithReturnType<void>;
export type FunctionWithParams<ReturnType, ParamsType> = (
  params: ParamsType
) => ReturnType;
export type FunctionWithOptionalParams<ReturnType, ParamsType> = (
  params?: ParamsType
) => ReturnType;
